import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { 
  FiCpu, FiSend, FiTerminal, FiPlay, FiShield,
  FiBookOpen, FiActivity, FiArrowRight, FiCommand, FiTrash2
} from 'react-icons/fi';
import Swal from 'sweetalert2';

export default function AIAgentWorkflowPage() {
  const { user } = useAuth();
  
  // ตรวจสอบสิทธิ์ไอที หรือเจ้าของระบบ
  const isITOrOwner = user?.role === 'owner' || user?.role === 'it' || user?.username === 'it' || user?.username === 'owner';
  
  // รายการเอเจ้นท์บอทในระบบ
  const [agents] = useState([
    {
      id: 'researcher',
      name: 'Ruby (AI Researcher) 🔍',
      roleName: 'นักวิจัยวิเคราะห์สถิติและการตลาด',
      emoji: '👩‍🔬',
      themeColor: '#06b6d4',
      speech: 'กำลังสแกนวิเคราะห์ประวัติคิวงานล้างแอร์ในระบบค่ะ ❄️',
      shortcuts: [
        { cmd: '/trend', label: 'วิเคราะห์เทรนด์ยอดขายแอร์บ้าน', text: 'วิเคราะห์แนวโน้มยอดขายแอร์บ้านในช่วง 30 วันที่ผ่านมา' },
        { cmd: '/kpi_summary', label: 'สรุปผลงานช่างล้างแอร์', text: 'สรุปการปฏิบัติงานและคะแนนประเมินเฉลี่ยของช่างในระบบ' }
      ]
    },
    {
      id: 'writer',
      name: 'Jasper (AI Writer) ✍️',
      roleName: 'ผู้สร้างสรรค์เนื้อหา & คอนเทนต์อัตโนมัติ',
      emoji: '👨‍🎨',
      themeColor: '#a855f7',
      speech: 'กำลังเขียนแคปชั่น Facebook เกี่ยวกับคำเตือนฟิวส์ขาดครับ ⚡',
      shortcuts: [
        { cmd: '/post', label: 'เขียนร่างโพสต์แนะนำบริการหน้าร้อน', text: 'เขียนร่างโพสต์ Facebook เรื่องความปลอดภัยในการใช้เครื่องใช้ไฟฟ้าช่วงหน้าร้อน' },
        { cmd: '/prompt', label: 'เขียน Prompt รูปภาพงานติดตั้งแอร์', text: 'เขียนคำบรรยายภาพ (Prompt) สำหรับนำไปเจนรูปงานติดตั้งแอร์บ้านเดี่ยว' }
      ]
    },
    {
      id: 'db_bot',
      name: 'DbBot (AI Database) 📦',
      roleName: 'ผู้ดูแลตรวจสอบระบบฐานข้อมูล CRM',
      emoji: '🤖',
      themeColor: '#10b981',
      speech: 'SELECT * FROM jobs WHERE status = "completed" 📦',
      shortcuts: [
        { cmd: '/check_db', label: 'ตรวจสภาพแถวข้อมูลคิวงานสะสม', text: 'ตรวจสอบสุขภาพฐานข้อมูลและแถวตารางข้อมูลคิวงาน' },
        { cmd: '/clean_logs', label: 'ทำความสะอาดประวัติการใช้งานเก่า', text: 'ทำความสะอาดไฟล์ข้อมูลประวัติการทำงานเก่าเพื่อเพิ่มพื้นที่จัดเก็บ' }
      ]
    },
    {
      id: 'security',
      name: 'Aegis (AI Security) 🛡️',
      roleName: 'ผู้พิทักษ์ความปลอดภัยเครือข่าย',
      emoji: '👮‍♂️',
      themeColor: '#f43f5e',
      speech: 'ตรวจสอบ Firewall และข้อมูลการล็อกอินของผู้ใช้งานระบบหลัก 🛡️',
      shortcuts: [
        { cmd: '/audit_logs', label: 'สแกนหาข้อผิดพลาดใน Logs ระบบ', text: 'สแกนหาข้อผิดพลาดและตรวจสอบความปลอดภัยใน Logs ระบบแอดมิน' },
        { cmd: '/active_users', label: 'สแกนพนักงานออนไลน์เวลานี้', text: 'แสดงจำนวนไอดีพนักงานและช่างที่เข้าใช้งานระบบขณะนี้' }
      ]
    }
  ]);

  const [activeAgent, setActiveAgent] = useState(agents[0]);
  
  // เก็บประวัติการแชทแยกตามตัวละคร AI
  const [chatHistory, setChatHistory] = useState({
    researcher: [
      { id: 1, sender: 'agent', text: 'สวัสดีค่ะ ฉันคือ Ruby ยินดีต้อนรับสู่อินเตอร์เฟสแชทโดยตรง! มีหัวข้อการตลาด สถิติ หรือประเมิน KPI ชิ้นไหนให้ฉันวิเคราะห์จากฐานข้อมูล แจ้งได้เลยค่ะ 🔍📊', time: '10:00' }
    ],
    writer: [
      { id: 1, sender: 'agent', text: 'ยินดีที่ได้คุยด้วยครับผม Jasper ฝ่ายสร้างสรรค์เนื้อหา! ต้องการให้แต่งแคปชั่นแฟนเพจ คิดแฮชแท็ก หรือร่างโปรโมชั่นหน้าร้อน ร้องขอได้ทันที ✍️🎨', time: '10:00' }
    ],
    db_bot: [
      { id: 1, sender: 'agent', text: 'ระบบเชื่อมต่อพร้อมบริการ บอร์ดควบคุมฐานข้อมูล DbBot ประสิทธิภาพความหน่วงเฉลี่ย 8ms. ต้องการให้ตรวจสภาพตาราง ค้นหาเรคอร์ดแปลกปลอม พิมพ์สั่งได้เลยครับ 🤖📦', time: '10:00' }
    ],
    security: [
      { id: 1, sender: 'agent', text: 'สวัสดีครับหัวหน้า! เจ้าหน้าที่วิเคราะห์ความมั่นคงปลอดภัย Aegis ตรวจตรา Logs ความพยายามบุกรุก และแบน IP แปลกปลอมพร้อมปฏิบัติงานครับ 👮‍♂️🔒', time: '10:00' }
    ]
  });

  const [inputVal, setInputVal] = useState('');
  const [isWorkflowRunning, setIsWorkflowRunning] = useState(false);
  const [runningStepMsg, setRunningStepMsg] = useState('');
  
  const [terminalLogs, setTerminalLogs] = useState([
    `[SYSTEM] AI Chatbot Agent Gateway initialized successfully.`,
    `[SYSTEM] Ruby, Jasper, DbBot, and Aegis agents loaded.`,
    `[SECURITY] Sentinel Aegis guarding database portal.`,
    `[DATABASE] DbBot synchronizing tables with MySQL host.`
  ]);

  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatHistory, activeAgent]);

  if (!isITOrOwner) {
    return <Navigate to="/admin/dashboard" />;
  }

  // ฟังก์ชันเขียน Log ลงใน Terminal
  const writeLog = (msg) => {
    const time = new Date().toLocaleTimeString('th-TH', { hour12: false });
    setTerminalLogs(prev => [...prev, `[${time}] ${msg}`]);
  };

  // เปลี่ยนบอทที่จะแชทด้วย
  const selectAgent = (agent) => {
    setActiveAgent(agent);
    writeLog(`Switched channel to ${agent.id.toUpperCase()}`);
  };

  // ส่งข้อความคุยกับ AI บอท
  const sendPromptToAgent = (promptText) => {
    if (!promptText.trim() || isWorkflowRunning) return;

    const timeStr = new Date().toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' });
    const userMsg = { id: Date.now(), sender: 'user', text: promptText, time: timeStr };

    // อัปเดตข้อความฝั่งผู้ใช้งาน
    setChatHistory(prev => ({
      ...prev,
      [activeAgent.id]: [...(prev[activeAgent.id] || []), userMsg]
    }));

    setIsWorkflowRunning(true);
    writeLog(`[CMD] Sending prompt to ${activeAgent.id.toUpperCase()}: "${promptText}"`);

    // จำลองกระบวนการประมวลผลคำสั่งหลังบ้านของเอเจ้นท์แต่ละตัว
    setTimeout(() => {
      let responseText = '';
      
      switch(activeAgent.id) {
        case 'researcher':
          if (promptText.includes('/trend')) {
            responseText = `📊 สรุปรายงานแนวโน้มยอดขายแอร์บ้านรอบ 30 วัน:\n- ยอดขายรวม: ฿480,000 (เติบโตขึ้น +15% เทียบกับเดือนก่อน)\n- รุ่นที่ขายดีที่สุด: Daikin Max Inverter (52 เครื่อง)\n- แนวโน้มหลัก: ลูกค้าหันมาสั่งซื้อแอร์ระบบประหยัดไฟเบอร์ 5 ระดับ 1-3 ดาว สูงขึ้นในช่วงฤดูร้อนนี้ค่ะ`;
          } else if (promptText.includes('/kpi')) {
            responseText = `📈 รายงานการประเมินผลช่างล้างแอร์ในระบบ:\n- จำนวนช่างปฏิบัติงาน: 8 คน\n- คะแนนรีวิวความพึงพอใจเฉลี่ย: 4.88 / 5 ดาว\n- ช่างยอดเยี่ยมอันดับ 1: ช่างสมชาย (ล้างเสร็จตรงเวลาและรับประกันงานสะอาดดีเยี่ยม)`;
          } else {
            responseText = `ฉันได้รับคำสั่งวิเคราะห์ข้อมูลเรื่อง "${promptText}" เรียบร้อยค่ะ จากการประมวลผลข้อมูลหลังบ้านพบว่าโครงสร้างงานจองคิวมีสถิติที่ตรงเป้าหมาย และระบบได้ทำสรุปผลการวิจัยส่งไปยังแดชบอร์ดหลักแล้วค่ะ 🔍📈`;
          }
          break;

        case 'writer':
          if (promptText.includes('/post')) {
            responseText = `✍️ ร่างบทความโพสต์ Facebook คอนเทนต์หน้าร้อน:\n\n"❄️ แอร์ไม่เย็น มีน้ำหยด ยอดไฟบ้านพุ่งกระฉูด! คลายความกังวลใจไปกับ Thunder Maxhome บริการล้างแอร์ทำความสะอาดลึกระดับนาโน ปราบฝุ่นสะสม กลิ่นเหม็นอับ มั่นใจทีมช่างผ่านใบรับรองอย่างเป็นทางการ...\n👉 สนใจจองคิวบริการด่วนดึงคิวว่างบนหน้าเว็บได้ตลอด 24 ชม.!"`;
          } else if (promptText.includes('/prompt')) {
            responseText = `🎨 คีย์พร้อมต์ AI สำหรับนำไปสร้างรูปภาพใน Midjourney:\n\n"A clean professional Thai air conditioning technician installing a sleek white air conditioner unit in a beautiful modern luxury concrete living room, warm soft interior lighting, cinematic, photorealistic, 8k resolution --ar 16:9 --style raw"`;
          } else {
            responseText = `Jasper ได้รับแนวคิดหัวข้อเพื่อนำไปวางโครงเรื่องเขียนบทความประชาสัมพันธ์เกี่ยวกับ "${promptText}" แล้วครับ! ผมได้บันทึกร่างเนื้อหาโพสต์นี้ลงสู่ฐานข้อมูลพร้อมแท็กแฮชแท็กที่เหมาะสมเรียบร้อยแล้ว ✍️🔥`;
          }
          break;

        case 'db_bot':
          if (promptText.includes('/check_db')) {
            responseText = `🤖 [Database Status Audit]:\n- การเชื่อมต่อ: ปกติ (Active)\n- ตารางทั้งหมด: 8 ตาราง (jobs, users, products, blocked_dates, system_logs, ...)\n- ไม่พบข้อมูลค้างชำรุดหรือดัชนีพัง (Index Cleaned 100%)`;
          } else if (promptText.includes('/clean_logs')) {
            responseText = `📦 ทำความสะอาดประวัติการล็อกระบบ Logs เก่าที่อายุเกิน 90 วัน เรียบร้อยแล้วครับ! ล้างแถวข้อมูล logs สำเร็จ 1,240 แถว เพิ่มพื้นที่ว่างให้เซิร์ฟเวอร์ MySQL`;
          } else {
            responseText = `DbBot ประมวลผลคำสั่งคิวรีระบบเรียบร้อยครับ ดำเนินการคัดกรองข้อมูลสำหรับคำสั่ง "${promptText}" และดำเนินการอัปเดตสถานะของเรคอร์ดเป้าหมายให้ถูกต้องเรียบร้อยแล้วครับ 📦🛡️`;
          }
          break;

        case 'security':
          if (promptText.includes('/audit_logs')) {
            responseText = `👮‍♂️ [Security Audit Summary Logs]:\n- ไม่พบการพยายามโจมตีแบบ SQL Injection\n- ล็อกความพยายามเข้าใช้งานแอดมินล้มเหลว: 0 ครั้งในรอบ 12 ชม.\n- พอร์ตทั้งหมดถูกปิดป้องกันความปลอดภัยสมบูรณ์แบบ`;
          } else if (promptText.includes('/active_users')) {
            responseText = `🛡️ ผู้ใช้ที่เข้าระบบขณะนี้:\n- แอดมิน/ฝ่ายบริการ: 2 ไอดี (it, owner)\n- ช่างซ่อมและช่างติดตั้งในเครือข่ายแอปมือถือ: 5 คน (สถานะ: กำลังสแตนด์บายรับงาน)`;
          } else {
            responseText = `เจ้าหน้าที่ตรวจสอบความปลอดภัย Aegis ได้สแกนพาสและประวัติกิจกรรมของข้อความ "${promptText}" เรียบร้อยแล้ว ไม่พบลายเซ็นต้องสงสัยใดๆ บนเซิร์ฟเวอร์หลักของบริษัทครับ ปลอดภัย 100% 👮‍♂️🔒`;
          }
          break;

        default:
          responseText = `ฉันดำเนินการประมวลผลคำสั่งสำเร็จเรียบร้อยแล้วค่ะ มีอะไรให้ฉันประสานงานดูแลช่วยเหลือต่อแจ้งมาได้เลยนะคะ`;
      }

      const agentMsg = { id: Date.now() + 1, sender: 'agent', text: responseText, time: timeStr };
      setChatHistory(prev => ({
        ...prev,
        [activeAgent.id]: [...(prev[activeAgent.id] || []), agentMsg]
      }));

      setIsWorkflowRunning(false);
      writeLog(`[SUCCESS] Response compiled by ${activeAgent.id.toUpperCase()}`);
    }, 1200);
  };

  const handleSendFormSubmit = (e) => {
    e.preventDefault();
    if (!inputVal.trim()) return;
    sendPromptToAgent(inputVal);
    setInputVal('');
  };

  // สั่งงานแบบ Shortcut ด่วน
  const triggerShortcut = (shortcutText) => {
    sendPromptToAgent(shortcutText);
  };

  // สั่งรัน Workflow ครบวงจร (แบบไปป์ไลน์ส่งต่อข้อมูล)
  const runWorkflowPipeline = async (type) => {
    if (isWorkflowRunning) return;
    setIsWorkflowRunning(true);

    const workflows = {
      marketing: {
        title: '📣 สร้างคอนเทนต์แชร์ความรู้ความปลอดภัยและโพสต์เพจ',
        steps: [
          { agent: 'researcher', log: 'Ruby สแกนเทรนด์ความปลอดภัยและงานล้างแอร์บ้านเดี่ยว...', msg: 'ค้นหาเทรนด์ไฟฟ้าหน้าร้อนเรียบร้อย 🔍' },
          { agent: 'writer', log: 'Jasper รับข้อมูลเพื่อเขียนบทความและคิดพร้อมต์เจนรูปภาพประกอบ...', msg: 'แต่งแคปชั่น FB และ Prompt รูปภาพเสร็จแล้ว ✍️' },
          { agent: 'db_bot', log: 'DbBot บันทึกแคปชั่นลงสู่ตารางคิวและตั้งเวลาโพสต์แฟนเพจอัตโนมัติ...', msg: 'บันทึกคิวโพสต์ล่วงหน้าลงฐานข้อมูลเรียบร้อย 📦' }
        ],
        successMsg: 'เสร็จสิ้นเวิร์กโฟลว์การตลาด AI เขียนคอนเทนต์และเตรียมข้อมูลโพสต์เพจล่วงหน้าลงในระบบเรียบร้อยแล้วครับ! 🎉'
      },
      audit: {
        title: '🛡️ ตรวจสอบช่องโหว่ความปลอดภัยและการลักลอบแฮกข้อมูล',
        steps: [
          { agent: 'security', log: 'Aegis แสกน System Logs ล่าสุด คัดกรองการล็อกอินผิดปกติ...', msg: 'สแกนพบล็อกอินล้มเหลว 0 ครั้ง 🛡️' },
          { agent: 'db_bot', log: 'DbBot ดึงข้อมูลพอร์ต SQL และรายการ IP แปลกปลอมส่งไปตรวจสอบ...', msg: 'ดึงรายการ IP บุกรุกส่งฝ่ายรักษาความปลอดภัย 📦' },
          { agent: 'security', log: 'Aegis ล้างเซสชันและตรวจสอบแบล็คลิสต์ไอดีบุกรุกออกจากระบบ CRM...', msg: 'ทำการสแกนเสร็จสิ้น ไม่มีบัญชีต้องสงสัย 👮‍♂️' }
        ],
        successMsg: 'การสแกนระบบความปลอดภัยเสร็จสมบูรณ์! ระบบปลอดภัยไร้รอยต่อ 🔒'
      }
    };

    const wf = workflows[type];
    if (!wf) return;

    Swal.fire({
      title: 'กำลังรัน Workflow AI...',
      text: wf.title,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    writeLog(`[WORKFLOW START] ${wf.title}`);

    for (let i = 0; i < wf.steps.length; i++) {
      const step = wf.steps[i];
      setRunningStepMsg(step.log);
      writeLog(step.log);
      await new Promise(resolve => setTimeout(resolve, 1500));
    }

    Swal.fire({
      title: 'รันเวิร์กโฟลว์สำเร็จ!',
      text: wf.successMsg,
      icon: 'success'
    });

    const timeStr = new Date().toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' });
    const successMsg = {
      id: Date.now(),
      sender: 'agent',
      text: `📢 รันเวิร์กโฟลว์สำเร็จ: [${wf.title}] ผลงานประมวลผลผ่านทุก Node ในระบบเรียบร้อยครับ! 🎉`,
      time: timeStr
    };

    setChatHistory(prev => ({
      ...prev,
      [activeAgent.id]: [...(prev[activeAgent.id] || []), successMsg]
    }));

    setRunningStepMsg('');
    setIsWorkflowRunning(false);
    writeLog(`[WORKFLOW COMPLETED] ${wf.title}`);
  };

  const currentChats = chatHistory[activeAgent.id] || [];

  return (
    <div className="space-y-6 pb-20 animate-fade-in text-gray-800 dark:text-gray-100 font-sans text-left h-[calc(100vh-120px)] flex flex-col">
      
      {/* 🚀 Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 flex-shrink-0">
        <div>
          <h1 className="text-xl font-black text-gray-850 dark:text-white flex items-center gap-2">
            <span className="text-indigo-500 animate-pulse"><FiCpu /></span> ศูนย์ควบคุม AI Agents แชทบอทอัจฉริยะ (AI Agent Hub)
          </h1>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            สั่งงานบอทแยกตามแผนกช่วยเหลือหลังบ้าน ดึงข้อมูล ครีเอทคอนเทนต์ และแสกนความปลอดภัยผ่านการแชทโดยตรง
          </p>
        </div>

        {/* ปุ่ม Workflow ด่วน */}
        <div className="flex gap-2">
          <button 
            disabled={isWorkflowRunning}
            onClick={() => runWorkflowPipeline('marketing')}
            className="bg-purple-600 hover:bg-purple-700 text-white text-[11px] font-bold py-1.5 px-3 rounded-lg shadow transition"
          >
            📢 รันการตลาดอัตโนมัติ
          </button>
          <button 
            disabled={isWorkflowRunning}
            onClick={() => runWorkflowPipeline('audit')}
            className="bg-rose-600 hover:bg-rose-700 text-white text-[11px] font-bold py-1.5 px-3 rounded-lg shadow transition"
          >
            🛡️ ตรวจความปลอดภัย
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 flex-1 min-h-0">
        
        {/* 🤖 1. พาเนลซ้าย: เลือกเอเจ้นท์บอท */}
        <div className="lg:col-span-1 bg-white dark:bg-[#131825] border border-gray-200 dark:border-[#1e2330] rounded-2xl p-4 flex flex-col gap-3 shadow-sm overflow-y-auto">
          <h3 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
            <FiActivity /> เลือกแผนก AI บอทช่วยเหลือ
          </h3>
          
          <div className="flex flex-col gap-2">
            {agents.map(agent => {
              const isActive = activeAgent.id === agent.id;
              return (
                <button
                  key={agent.id}
                  onClick={() => selectAgent(agent)}
                  className={`w-full text-left p-3 rounded-xl border transition flex items-center gap-3
                    ${isActive 
                      ? 'border-indigo-500 bg-indigo-50/40 dark:bg-indigo-950/20' 
                      : 'border-transparent hover:bg-gray-50 dark:hover:bg-slate-900/50'
                    }
                  `}
                >
                  <div 
                    className="w-8 h-8 rounded-lg flex items-center justify-center text-sm shadow-sm"
                    style={{ backgroundColor: `${agent.themeColor}15`, border: `1px solid ${agent.themeColor}30` }}
                  >
                    {agent.emoji}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-[11px] font-bold text-gray-800 dark:text-white truncate">{agent.name}</div>
                    <div className="text-[9px] text-gray-500 dark:text-gray-400 truncate">{agent.roleName}</div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        {/* 💬 2. พาเนลกลาง: หน้าต่างแชทกับบอท */}
        <div className="lg:col-span-2 bg-white dark:bg-[#131825] border border-gray-200 dark:border-[#1e2330] rounded-2xl flex flex-col shadow-sm min-h-0">
          
          {/* ชื่อเอเจ้นท์ปัจจุบัน */}
          <div className="p-3 border-b border-gray-200 dark:border-[#1e2330] flex items-center justify-between bg-gray-50/50 dark:bg-[#1b2132]/30 rounded-t-2xl">
            <div className="flex items-center gap-2.5">
              <div 
                className="w-7 h-7 rounded-md flex items-center justify-center text-sm"
                style={{ backgroundColor: `${activeAgent.themeColor}20`, color: activeAgent.themeColor }}
              >
                {activeAgent.emoji}
              </div>
              <div>
                <h4 className="text-[11px] font-black text-gray-800 dark:text-white">{activeAgent.name}</h4>
                <span className="text-[8px] text-emerald-500 font-bold flex items-center gap-1">● บอทเชื่อมต่อออนไลน์</span>
              </div>
            </div>
            <span className="text-[8px] bg-indigo-500/10 text-indigo-500 font-mono py-0.5 px-2 rounded-full font-bold">
              ID: {activeAgent.id.toUpperCase()}
            </span>
          </div>

          {/* กล่องประวัติการแชท */}
          <div className="flex-1 overflow-y-auto p-4 space-y-4 text-[11px] custom-scrollbar">
            {currentChats.map(msg => (
              <div 
                key={msg.id} 
                className={`flex flex-col max-w-[85%] ${msg.sender === 'user' ? 'ml-auto items-end' : 'mr-auto items-start'}`}
              >
                <span className="text-[8px] text-gray-400 mb-0.5 font-mono">
                  {msg.sender === 'user' ? 'ผู้จัดการ (BOSS)' : activeAgent.id.toUpperCase()}
                </span>
                <div 
                  className={`p-2.5 rounded-xl leading-relaxed shadow-sm whitespace-pre-line
                    ${msg.sender === 'user' 
                      ? 'bg-indigo-600 text-white rounded-tr-none' 
                      : 'bg-gray-100 dark:bg-[#1e2330] text-gray-800 dark:text-gray-100 border border-gray-200 dark:border-gray-800 rounded-tl-none'
                    }
                  `}
                >
                  {msg.text}
                </div>
                <span className="text-[7px] text-gray-400 mt-1 opacity-75">{msg.time}</span>
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>

          {/* ส่วนส่งข้อความฟอร์มแชท */}
          <form onSubmit={handleSendFormSubmit} className="p-3 border-t border-gray-200 dark:border-[#1e2330] flex gap-2 flex-shrink-0">
            <input 
              type="text" 
              value={inputVal}
              onChange={e => setInputVal(e.target.value)}
              disabled={isWorkflowRunning}
              placeholder={`พิมพ์ข้อความคำสั่งหา ${activeAgent.id} หรือใช้คำสั่งลัด / ฝั่งขวา...`}
              className="flex-1 p-2.5 bg-gray-50 dark:bg-[#1e2330]/40 border border-gray-200 dark:border-gray-800 text-[11px] rounded-xl outline-none focus:border-indigo-500 text-gray-800 dark:text-white disabled:opacity-50"
            />
            <button 
              type="submit" 
              disabled={isWorkflowRunning || !inputVal.trim()}
              className="bg-indigo-600 hover:bg-indigo-500 disabled:bg-gray-600 text-white px-4 rounded-xl transition shadow-md flex items-center justify-center"
            >
              <FiSend size={12} />
            </button>
          </form>

        </div>

        {/* 📚 3. พาเนลขวา: คำสั่งรัด (Shortcuts) & คู่มือใช้งาน */}
        <div className="lg:col-span-1 flex flex-col gap-4 overflow-y-auto">
          
          {/* บล๊อกคำสั่งลัด */}
          <div className="bg-white dark:bg-[#131825] border border-gray-200 dark:border-[#1e2330] rounded-2xl p-4 shadow-sm">
            <h3 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-1.5">
              <FiCommand /> คำสั่งลัดส่งด่วน (Shortcuts)
            </h3>
            
            <div className="flex flex-col gap-2">
              {activeAgent.shortcuts.map((sh, idx) => (
                <button
                  key={idx}
                  onClick={() => triggerShortcut(sh.text)}
                  disabled={isWorkflowRunning}
                  className="w-full text-left p-2.5 bg-gray-50 dark:bg-slate-900/60 border border-gray-200 dark:border-gray-800 rounded-xl hover:border-indigo-500 transition group flex items-start justify-between gap-1 disabled:opacity-50"
                >
                  <div className="min-w-0">
                    <span className="text-[9px] font-bold text-indigo-500 font-mono block mb-0.5">{sh.cmd}</span>
                    <span className="text-[10px] text-gray-700 dark:text-gray-300 font-bold block">{sh.label}</span>
                  </div>
                  <FiArrowRight size={12} className="text-gray-400 group-hover:text-indigo-500 transition mt-1 flex-shrink-0" />
                </button>
              ))}
            </div>
          </div>

          {/* คู่มือวิธีใช้งานสำหรับแอดมิน */}
          <div className="bg-white dark:bg-[#131825] border border-gray-200 dark:border-[#1e2330] rounded-2xl p-4 shadow-sm flex-1">
            <h3 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2 flex items-center gap-1.5">
              <FiBookOpen /> คำแนะนำวิธีใช้ (Guide)
            </h3>
            
            <div className="text-[10px] text-gray-500 dark:text-gray-400 space-y-2.5 leading-relaxed">
              <p>
                <strong>1. สั่งวิเคราะห์ข้อมูลเชิงลึก:</strong> คลิกแท็บแผนก AI ที่ต้องการทางด้านซ้ายเพื่อเปิดช่องแชทเฉพาะเจาะจง
              </p>
              <p>
                <strong>2. ใช้คำสั่งลัดด่วน:</strong> กดปุ่มคำสั่งด้านบนเพื่อพิมพ์คีย์เวิร์ดลัดส่งบอททันที บอทจะเชื่อมข้อมูลหลังบ้านและตอบกลับอย่างรวดเร็ว
              </p>
              <p>
                <strong>3. รันโปรเซสข้ามแผนก:</strong> กดปุ่ม <em>"รันการตลาดอัตโนมัติ"</em> หรือ <em>"ตรวจความปลอดภัย"</em> ด้านบน เพื่อจำลอง Pipeline เชื่อมโยงระบบทั้งหมดของบริษัท
              </p>
            </div>
          </div>

        </div>

      </div>

      {/* 💻 ส่วนแสดงประวัติการทำงานสด Terminal Log Console */}
      <div className="bg-[#0b0f19] border border-[#1e2330] rounded-2xl p-3 shadow-md flex-shrink-0 flex flex-col h-[130px]">
        <div className="flex justify-between items-center mb-1.5 pb-1 border-b border-gray-800/80">
          <div className="flex items-center gap-1.5 text-cyan-400 font-mono text-[9px] font-bold">
            <FiTerminal /> Real-time System Agent Execution Log Console
          </div>
          <button 
            onClick={() => setTerminalLogs([`[SYSTEM] Console logs flushed.`])}
            className="text-gray-500 hover:text-gray-300 font-mono text-[8px] flex items-center gap-1"
          >
            <FiTrash2 size={10} /> Clear
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto font-mono text-[8.5px] text-gray-400 space-y-0.5 custom-scrollbar text-left select-text">
          {terminalLogs.map((tLog, idx) => (
            <div 
              key={idx} 
              className={
                tLog.includes('[SYSTEM]') 
                  ? 'text-cyan-500/90' 
                  : tLog.includes('[CMD]') 
                    ? 'text-yellow-500 font-bold' 
                    : tLog.includes('completed') || tLog.includes('successful') || tLog.includes('เสร็จสิ้น')
                      ? 'text-emerald-400' 
                      : 'text-gray-400'
              }
            >
              {tLog}
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}
